<template>
  <div class="page-container">
    <van-nav-bar
      v-if="!$route.query.terminal"
      class="lottery-nav"
      title=""
      fixed
      :z-index="10"
      @click-left="$router.replace({ name: 'home' })"
      left-arrow>
    </van-nav-bar>
    <div class="page-bg" id="page">
      <div class="shake-bg">
        <img
          v-if="!loading"
          class="redpack-bg"
          src="../../assets/img/shake/shake_red_bg.png"
          alt="" />
        <div :class="loading ? 'animation-bg-animation' : 'animation-bg'">
          <img
            :class="loading ? 'top-redpack-bg-animation' : 'top-redpack-bg'"
            src="../../assets/img/shake/shake_top_icon.png"
            alt="" />
          <img
            :class="
              loading ? 'bottom-redpack-bg-animation' : 'bottom-redpack-bg'
            "
            src="../../assets/img/shake/shake_bottom_icon.png"
            alt="" />
        </div>
        <div v-if="!loading" class="center-bg">
          <div class="info-title">摇动手机，开启红包！</div>
          <img
            class="yaoyiyao-btn"
            src="../../assets/img/shake/shake_btn.png"
            alt=""
            @click="onShake" />
        </div>
      </div>
      <div class="rule-bg">
        <div class="rules" v-html="rules"></div>
      </div>
      <audio ref="shakeAudio" id="shakeAudio">
        您的浏览器不支持 audio 标签。
      </audio>
    </div>
    <van-popup
      v-model="showResult"
      class="popup-bg"
      :close-on-click-overlay="false">
      <div class="main-bg">
        <div class="info-bg">
          <div class="title">{{ popParams.amount / 100 }}元</div>
          <div class="content">有效期{{ popParams.days }}天</div>
          <div class="content">{{ popParams.condStartAmt }}</div>
        </div>
        <img
          class="close-btn"
          src="../../assets/img/shake/pop_close_icon.png"
          @click="onClose" />
        <img
          class="useBtn"
          src="../../assets/img/shake/shake_use_btn.png"
          @click="onCommitUse" />
      </div>
    </van-popup>
  </div>
</template>
<script src="http://res.wx.qq.com/open/js/jweixin-1.6.0.js" />
<script>
import { Icon, Popup } from "vant"
import Shake from "shake.js"
import { Howl, Howler } from "howler"
import { shakeLottery } from "../../api/lottery"
import emptyaudioMp3 from "../../assets/img/shake/emptyaudio.mp3"
import lotteryMp3 from "../../assets/img/shake/shakelottery.mp3"
import lotteryResultMp3 from "../../assets/img/shake/shakeresult.mp3"

export default {
  components: {
    [Popup.name]: Popup,
    [Icon.name]: Icon
  },
  data() {
    return {
      loading: false, //防止摇摆过程中造成的误操作
      myShakeEvent: undefined,
      showResult: false,
      rules:
        "1、活动期间，用户每天登录微信菜单，点击【摇一摇领红包】活动，有机会获得红包，每人每天可摇一次;<br />2、投资起息之后可再摇一次，有效期为一天;<br />3、摇一摇前，请提前登录并微信绑定天安金交所账户;<br />4、红包奖励将在摇到奖励后发放至天安金交所注册账户中。", //<br />5、本活动最终解释权归天安金交所所有。

      iOSAudio: undefined,

      popParams: {
        amount: 0,
        days: 0,
        condStartAmt: "",
        times: 0
      }
    }
  },
  directives: {
    trigger: {
      inserted(el, binging) {
        console.log("自动触发事件 el == %O, binging == %O", el, binging)
        el.click()
      }
    }
  },
  mounted() {
    if (
      this.userInfo.custChannel.toLowerCase() === "ta" &&
      !this.userInfo.orgReferrerUserId &&
      this.userInfo.custType > 0
    ) {
      this.initAudioPlay()
      let ua = navigator.userAgent.toLowerCase()
      if (ua.indexOf("like mac os x") > 0) {
        console.log("ua == %O", ua)
        let reg = /os [\d._]*/gi
        let verinfo = ua.match(reg)
        let version = (verinfo + "")
          .replace(/[^0-9|_.]/gi, "")
          .replace(/_/gi, ".")
        if (parseFloat(version) >= 13.3) {
          this.ios13granted()
        } else {
          this.initShake()
        }
      } else {
        this.initShake()
      }
    } else {
      this.$router.replace({ name: "home" })
    }
  },
  created() {},
  methods: {
    isPhoneiOS() {
      const ua = navigator.userAgent.toLowerCase()
      //判断是否是安卓系统
      const isAndroid = ua.indexOf("android") > -1 || ua.indexOf("adr") > -1
      //判断是否是iOS系统
      const isiOS = !!ua.match(/\(i[^;]+;( u;)? cpu.+mac os x/)
      return isiOS
    },
    initAudioPlay() {
      if (this.isPhoneiOS()) {
        console.log("iOS")
        window.WeixinJSBridge &&
          window.WeixinJSBridge.invoke(
            "getNetworkType",
            {},
            () => {
              this.iOSAudio = this.$refs.shakeAudio
              this.iOSAudio.src = emptyaudioMp3
              this.iOSAudio.play()
            },
            false
          )
      } else {
        console.log("Android")
        let soundbgm = new Howl({
          src: [emptyaudioMp3],
          preload: true
        })
        soundbgm.on("load", () => {
          soundbgm.play()
        })
      }
    },
    onClose() {
      this.showResult = false
    },
    onCommitUse() {
      this.$router.replace({ name: "invest" })
    },
    initShake() {
      this.myShakeEvent = new Shake({
        threshold: 15, // 摇动阈值
        timeout: 1000 // 事件发生频率，是可选值
      })
      this.myShakeEvent.start()
      window.addEventListener("shake", this.devicemotion, false) // devicemotion shake
    },
    ios13granted() {
      if (
        typeof window.DeviceMotionEvent !== "undefined" &&
        typeof window.DeviceMotionEvent.requestPermission === "function"
      ) {
        window.DeviceMotionEvent.requestPermission()
          .then((permissionState) => {
            if (permissionState === "granted") {
              console.log("摇一摇")
              this.initShake() //摇一摇
            } else if (permissionState === "denied") {
              // 打开的链接不是https开头
              this._showTipsInfo(
                "温馨提示",
                "当前iOS系统拒绝访问动作与方向，请退出登录重新进入活动页面获取权限。或直接‘点击摇一摇’参与活动。",
                "",
                "好的",
                () => {},
                () => {}
              )
            }
          })
          .catch((error) => {
            this._showTipsInfo(
              "温馨提示",
              "由于iOS系统需要手动获取访问动作与方向的权限，为保障活动的正常进行，请在访问提示中点击允许。",
              "",
              "好的",
              () => {
                this.ios13granted()
              },
              () => {}
            )
          })
      } else {
        // 处理常规的非iOS 13+设备
        this.$toast("设备不支持摇一摇功能，请点击摇一摇参与活动！")
      }
    },
    // 设备运动 方法
    devicemotion(event) {
      if (event) {
        event.preventDefault()
      }
      if (!this.loading && !this.showResult) {
        this.loading = true
        if (window.navigator.vibrate) {
          navigator.vibrate(500)
        }
        if (this.isPhoneiOS()) {
          if (!this.iOSAudio) {
            this.iOSAudio = new Audio(lotteryMp3)
          } else {
            this.iOSAudio.src = lotteryMp3
          }
          this.iOSAudio.play()
        } else {
          let soundbgm = new Howl({
            src: [lotteryMp3],
            preload: true
          })
          soundbgm.play()
        }
        setTimeout(() => {
          this.loading = false
          this.startLottery()
        }, 2000)
      }
    },
    startLottery() {
      shakeLottery()
        .then((data) => {
          this.popParams = data
          this.showResult = true
          if (this.isPhoneiOS()) {
            this.iOSAudio.src = lotteryResultMp3
            this.iOSAudio.play()
          } else {
            let soundbgm = new Howl({
              src: [lotteryResultMp3],
              preload: true
            })
            soundbgm.play()
          }
          if (window.navigator.vibrate) {
            navigator.vibrate(500)
          }
        })
        .catch((e) => {
          this.$toast(e.msg || e.message)
        })
    },
    onShake(event) {
      this.devicemotion(event)
    }
  },
  beforeDestroy() {
    if (this.myShakeEvent) {
      this.myShakeEvent.stop()
      window.removeEventListener("shake", this.devicemotion, false) // devicemotion shake
    }
  }
}
</script>
<style lang="less" scoped>
.lottery-nav {
  background-color: transparent;
  &::after {
    display: none;
  }
}
.page-bg {
  position: relative;
  background-image: url(../../assets/img/shake/shake_bg.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  width: 100%;
  // min-height: calc(100vh - 45px);
  // min-height: 100vh;
  height: 812px;
  margin-top: -45px;
  .shake-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    .redpack-bg {
      position: relative;
      top: calc(50% - 210px);
      width: 100%;
    }

    .animation-bg,
    .animation-bg-animation {
      opacity: 0;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      .top-redpack-bg,
      .top-redpack-bg-animation {
        width: 100%;
        margin-top: 50%;
      }
      .top-redpack-bg-animation {
        animation: topMove 2s ease-in infinite;
        -moz-animation: topMove 2s ease-in infinite; /* Firefox */
        -webkit-animation: topMove 2s ease-in infinite; /* Safari and Chrome */
        -o-animation: topMove 2s ease-in infinite; /* Opera */
        animation-iteration-count: 1; /*动画只执行一次*/
        -moz-animation-iteration-count: 1;
        -webkit-animation-iteration-count: 1;
        -o-animation-iteration-count: 1;
        animation-fill-mode: forwards; /*让动画停留在最后一帧 */
        -moz-animation-fill-mode: forwards;
        -webkit-animation-fill-mode: forwards;
        -o-animation-fill-mode: forwards;
      }
      .bottom-redpack-bg,
      .bottom-redpack-bg-animation {
        width: 100%;
        margin-top: -1.5%;
      }
      .bottom-redpack-bg-animation {
        animation: bottomMove 2s ease-in infinite;
        -moz-animation: bottomMove 2s ease-in infinite; /* Firefox */
        -webkit-animation: bottomMove 2s ease-in infinite; /* Safari and Chrome */
        -o-animation: bottomMove 2s ease-in infinite; /* Opera */
        animation-iteration-count: 1; /*动画只执行一次*/
        -moz-animation-iteration-count: 1;
        -webkit-animation-iteration-count: 1;
        -o-animation-iteration-count: 1;
        animation-fill-mode: forwards; /*让动画停留在最后一帧 */
        -moz-animation-fill-mode: forwards;
        -webkit-animation-fill-mode: forwards;
        -o-animation-fill-mode: forwards;
      }
      @keyframes topMove {
        0% {
          transform: translateY(0);
        }
        100% {
          transform: translateY(-70%);
          opacity: 0.7;
        }
      }
      @keyframes bottomMove {
        0% {
          transform: translateY(0);
        }
        100% {
          transform: translateY(50%);
          opacity: 0.7;
        }
      }
    }
    .animation-bg-animation {
      opacity: 1;
    }
    .center-bg {
      z-index: 99;
      position: absolute;
      left: 0;
      width: 100%;
      top: calc(50% + 10px);
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .info-title {
        font-size: 17px;
        color: #ffffff;
        line-height: 29px;
        text-shadow: 0px 0px 3px rgba(192, 26, 27, 0.83);
      }
      .yaoyiyao-btn {
        margin-top: 10px;
        object-fit: cover;
        height: 44px;
      }
    }
  }
  .rule-bg {
    position: absolute;
    bottom: 18px;
    left: 31px;
    right: 34px;
    background-color: rgba(255, 255, 255, 0.39);
    // opacity: 0.39;
    border-radius: 2px;
    .rules {
      margin: 14px 14px 17px 9px;
      font-size: 11px;
      font-weight: 400;
      color: #fffefe;
      letter-spacing: 2px;
      line-height: 17px;
    }
  }
}
.popup-bg {
  background-color: transparent;
  .main-bg {
    width: 310px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .info-bg {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 6px;
      width: 295px;
      height: 298px;
      background-image: url(../../assets/img/shake/pop_bg.png);
      background-size: 100% 100%;
      background-repeat: no-repeat;
      .title {
        margin-top: 30px;
        font-size: 50px;
        font-weight: 800;
        color: #ffffff;
        line-height: 73px;

        background: linear-gradient(0deg, #ff5230 0%, #ff8d1e 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
      .content {
        font-size: 12px;
        font-weight: 400;
        color: #f76239;
      }
    }
    .close-btn {
      position: absolute;
      right: 0;
      width: 24px;
      height: 24px;
      top: 0px;
    }
    .useBtn {
      margin-top: 5px;
      height: 43px;
    }
  }
}
@keyframes play {
  25% {
    transform: rotate(-40deg);
  }
  75% {
    transform: rotate(40deg);
  }
  100% {
    transform: rotate(0deg);
  }
}
@keyframes shake {
  from {
    transform: rotate(0deg);
  }
  4% {
    transform: rotate(10deg);
  }
  12.5% {
    transform: rotate(-10deg);
  }
  21% {
    transform: rotate(10deg);
  }
  29% {
    transform: rotate(-10deg);
  }
  37.5% {
    transform: rotate(10deg);
  }
  46% {
    transform: rotate(-10deg);
  }
  50%,
  to {
    transform: rotate(0deg);
  }
}
</style>
